import React from "react";
import { SubmitButton } from "../SubmitButton";
import { Progress } from "../Progress";
import style from "./style.module.scss";
import { SkipTourLabel } from "../SkipTourLabel";
import { Content } from "../Content";
import { SkipTourButton } from "../SkipTourButton";
const BUTTON_LABEL = { NEXT: "Next", FINISH: "Finish" };
/**
 * TourBox
 *  - A component to be used instead the default Tooltip excluding the arrow of Page Tour.
 */
export function TourBox(props) {
  const { index, step, size, closeProps, primaryProps, tooltipProps } = props;

  const getProgressLabel = () => `${index}/${size - 1}`;
  const isSkipButtonVisible = () => (index === 0 ? true : false);
  const getPrimaryButtonLabel = () =>
    index === size - 1 ? BUTTON_LABEL.FINISH : BUTTON_LABEL.NEXT;

  return (
    <div className={style.tourCard} {...tooltipProps}>
      <div className={style.tourCardHeader}>
        <Progress label={getProgressLabel()} />
        <SkipTourLabel {...closeProps} visible={!isSkipButtonVisible()} />
      </div>
      <div className={style.tourCardBody}>
        <Content content={step.content} />
      </div>
      {!step.spotlightClicks ? (
        <div className={style.tourCardFooter}>
          <SkipTourButton {...closeProps} visible={isSkipButtonVisible()} />
          <SubmitButton
            {...primaryProps}
            buttonText={getPrimaryButtonLabel()}
          />
        </div>
      ) : null}
    </div>
  );
}
